import React from "react"
import { useTranslation } from "react-i18next"
import { useMediaQuery } from "react-responsive"
import { Box, Typography } from "src/UILibrary"
import "./office_item.scss"

type Props = {
  title: string
  address: string
  operatingTime: string
  breakTime: string
  support: string
  mapURL: string
}

export const OfficeItem = ({
  title,
  address,
  operatingTime,
  breakTime,
  support,
  mapURL,
}: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: "top" })

  const isPC = useMediaQuery({ query: "(min-width: 1050px)" })

  return (
    <Box mt="20px" display={isPC ? "flex" : "block"} width="100%">
      <Box className="office-img-container">
        <iframe
          src={mapURL}
          className="office-img"
          style={{ border: 0 }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </Box>

      <Box width={isPC ? "50%" : "100%"} display="flex">
        <Box className="office-detail" sx={{ maxWidth: "430px" }}>
          <Typography.SubHeadNormal color="textPrimary" lineHeight={1.25} mr={1.25}>
            {title}
          </Typography.SubHeadNormal>
          <Box sx={{ display: "flex", mt: "20px" }}>
            <Typography.DetailText sx={{ minWidth: "80px", fontFamily: "Noto Sans JP !important" }}>
              {t("address")}
            </Typography.DetailText>
            <Typography.DetailText>|</Typography.DetailText>
            <Typography.DetailText sx={{ ml: "20px", fontFamily: "Noto Sans JP !important" }}>
              {address}
            </Typography.DetailText>
          </Box>
          <Box sx={{ display: "flex", mt: "10px" }}>
            <Typography.DetailText sx={{ minWidth: "80px", fontFamily: "Noto Sans JP !important" }}>
              {t("operation_time")}
            </Typography.DetailText>
            <Typography.DetailText>|</Typography.DetailText>
            <Typography.DetailText sx={{ ml: "20px", fontFamily: "Noto Sans JP !important" }}>
              {operatingTime}
            </Typography.DetailText>
          </Box>
          <Box sx={{ display: "flex", mt: "10px" }}>
            <Typography.DetailText sx={{ minWidth: "80px", fontFamily: "Noto Sans JP !important" }}>
              {t("rest_day")}
            </Typography.DetailText>
            <Typography.DetailText>|</Typography.DetailText>
            <Typography.DetailText sx={{ ml: "20px", fontFamily: "Noto Sans JP !important" }}>
              {breakTime}
            </Typography.DetailText>
          </Box>
          <Box sx={{ display: "flex", mt: "10px" }}>
            <Typography.DetailText sx={{ minWidth: "80px", fontFamily: "Noto Sans JP !important" }}>
              {t("support")}
            </Typography.DetailText>
            <Typography.DetailText>|</Typography.DetailText>
            <Typography.DetailText sx={{ ml: "20px", fontFamily: "Noto Sans JP !important" }}>
              {support}
            </Typography.DetailText>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}
